import { Offcanvas } from 'react-bootstrap';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useToast } from 'context/ToastContext';
import type { TariffPlan } from '../TariffItem';
import ApplicationForm from './ApplicationForm';
import {
    getApplicationInitialValues,
    submitApplication,
    validateApplication,
} from './model';

interface Props {
    show: boolean;
    onHide: () => void;
    plan: TariffPlan | null;
    accountUuid: string;
}

const OffApplication = ({ show, onHide, plan, accountUuid }: Props) => {
    const { t } = useTranslation(['Tariff', 'common']);
    const { showToast } = useToast();

    return (
        <Offcanvas show={show} onHide={onHide} placement="end" className="off-application">
            <Offcanvas.Header className="border-bottom" closeButton>
                <Offcanvas.Title>{t('application.title')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                <Formik
                    enableReinitialize
                    initialValues={getApplicationInitialValues(plan, accountUuid)}
                    validate={(values) => validateApplication(values, t)}
                    onSubmit={(values, helpers) =>
                        submitApplication(values, helpers, { t, showToast, onHide })
                    }
                >
                    {({ handleSubmit, isSubmitting, errors, touched }) => (
                        <ApplicationForm
                            handleSubmit={handleSubmit}
                            isSubmitting={isSubmitting}
                            errors={errors}
                            touched={touched}
                        />
                    )}
                </Formik>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffApplication;
